export class CompanySettingResponseModel {
    
    csvColumnOrder?: string[]; // List of csv column order for export.
}
